import { CardiacArrestConstants } from './cardiacArrest.constants'
import { ICardiacArrestActions, ICardiacArrestState } from './cardiacArrest.types'

export const initialCardiacArrestState: ICardiacArrestState = {
  endCprButtonClickCount: 0,
  airwayButtonClickCount: 0,
  defibButtonClickCount: 0,
  amiodaroneButtonClickCount: 0,
  epiButtonClickCount: 0,
  atropineButtonClickCount: 0,
  intubationButtonClickCount: 0,
  ivButtonClickCount: 0,
  bvmButtonClickCount: 0,
  endCprButtonSavedTime: 0,
  airwayButtonSavedTime: 0,
  defibButtonSavedTime: 0,
  amiodaroneButtonSavedTime: 0,
  epiButtonSavedTime: 0,
  atropineButtonSavedTime: 0,
}

export function cardiacArrestReducer(
  state: ICardiacArrestState = initialCardiacArrestState,
  action: ICardiacArrestActions
): ICardiacArrestState {
  switch (action.type) {
    case CardiacArrestConstants.UPDATE_END_CPR:
      return { ...state, endCprButtonClickCount: state.endCprButtonClickCount + 1, endCprButtonSavedTime: Date.now() }
    case CardiacArrestConstants.UPDATE_AIRWAY:
      return { ...state, airwayButtonClickCount: state.airwayButtonClickCount + 1, airwayButtonSavedTime: Date.now() }
    case CardiacArrestConstants.UPDATE_DEFIB:
      return { ...state, defibButtonClickCount: state.defibButtonClickCount + 1, defibButtonSavedTime: Date.now() }
    case CardiacArrestConstants.UPDATE_AMIODARONE:
      return {
        ...state,
        amiodaroneButtonClickCount: state.amiodaroneButtonClickCount + 1,
        amiodaroneButtonSavedTime: Date.now(),
      }
    case CardiacArrestConstants.UPDATE_EPI:
      return { ...state, epiButtonClickCount: state.epiButtonClickCount + 1, epiButtonSavedTime: Date.now() }
    case CardiacArrestConstants.UPDATE_ATROPINE:
      return {
        ...state,
        atropineButtonClickCount: state.atropineButtonClickCount + 1,
        atropineButtonSavedTime: Date.now(),
      }
    case CardiacArrestConstants.UPDATE_INTUBATION:
      return { ...state, intubationButtonClickCount: state.intubationButtonClickCount + 1 }
    case CardiacArrestConstants.UPDATE_INITIATE_IV:
      return { ...state, ivButtonClickCount: state.ivButtonClickCount + 1 }
    case CardiacArrestConstants.UPDATE_BVM:
      return { ...state, bvmButtonClickCount: state.bvmButtonClickCount + 1 }
    default:
      return state
  }
}
